import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faqItems } from '@/data/faq-items';
import { translate } from '@/translations';
import { logOpenFaqQuestion } from '@/utils/analytics-utils';

export const FAQSectionHome = () => {
  const { t } = useTranslation('faq');
  const [activeIndex, setActiveIndex] = useState(null);

  const openQuestion = (id: number) => {
    const newIndex = id === activeIndex ? null : id;
    setActiveIndex(newIndex);

    if (newIndex) {
      logOpenFaqQuestion(t(faqItems[newIndex].title));
    }
  };

  return (
    <div className="section flex flex-col gap-5">
      <div className="flex justify-center">
        <h1 className="section-title">{t('title')}</h1>
      </div>

      <div className="flex justify-center">
        <div className="border-t border-[#A8A8A8] mt-8 md:w-4/6">
          <div>
            {faqItems.map((faqItem) => (
              <div key={faqItem.id} className="border-b border-[#A8A8A8]">
                <div
                  onClick={() => openQuestion(faqItem.id)}
                  className="flex items-center text-lg sm:text-xl font-semibold gap-4 py-4"
                >
                  <span
                    className={`cursor-pointer transition-transform duration-300 ease-in-out transform text-emerald-800 font-bold ${
                      activeIndex === faqItem.id ? 'rotate-0' : 'rotate-180'
                    }`}
                  >
                    {activeIndex === faqItem.id ? '×' : '+'}
                  </span>
                  <span>{translate(faqItem.title)}</span>
                </div>

                <div
                  className={clsx(
                    'overflow-hidden transition-all duration-500',
                    activeIndex === faqItem.id ? 'max-h-screen' : 'max-h-0'
                  )}
                >
                  {activeIndex === faqItem.id && (
                    <div className="pl-14 mb-3 sm:pl-16 sm:mb-5 text-sm md:text-base">
                      <p className="leading-6 md:leading-8 xl:leading-10">
                        {translate(faqItem.content)}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
